<template>
	<div class="collect-page">
		<div class="mains-content">
      <div class="page-left">
        <div class="member-box"><member :mobile="formMobile" :integral="true" @handleUser="memberChange"></member></div>
        <div class="right-box">
          <div v-if="listSelected.length == 0 ? true:false" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/fooBath_empty.png" alt="">
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
            <el-row class="tables-title">
              <el-col :span="8" class="titles"><div class="goodName">商品名称</div></el-col>
              <el-col :span="4" class="titles center">原价</el-col>
              <el-col :span="5" class="titles center">积分</el-col>
              <el-col :span="5" class="titles center"
                >数量</el-col
              >
              <el-col :span="2" class="titles right">操作</el-col>
            </el-row>
            <div class="tables p30 scroll-auto">
              <div
                class="boxs"
                v-for="(item, index) in listSelected"
                :key="index"
              >
                <el-row>
                  <el-col :span="8" class="titles "><div class="goodName fb">{{
                    item.yskItemName
                  }}</div></el-col>
                  <el-col :span="4" class="center fb">
                    ￥{{ item.priceType == "floating" ? item.priceRange : item.salePrice }}
                  </el-col>
                  <el-col :span="5" class="center fb">
                    {{ item.integralPrice }}
                  </el-col>
                  <el-col :span="5" class="nums center">
                    <span class="del-img" @click="blurItem('del',  item)">
                      <img src="../../../assets/images/new/del.png" alt="">
                    </span>
                    <el-input v-model="item.itemNum" readonly="" size="mini" style="width: 40px;"></el-input>
                    <span class="del-img" @click="blurItem('add',item)">
                      <img src="../../../assets/images/new/add.png" alt="">
                    </span>
                  </el-col>
                  <el-col :span="2" class="detail right">
                    <span
                      @click="showPrice(item)"
                      v-if="shopInfo.shopBizConfig.changePriceFlag && item.priceType != 'floating'"
                      class="el-icon-edit-outline jishi cur mr10"
                    ></span>
                    <i
                      class="el-icon-delete delete"
                      @click="deleteListSelected(item, index)"
                    ></i>
                  </el-col>
                </el-row>
                <div class="right-content p10">
                  <span class="color666 fontSize16 mr10">服务技师 :</span>
                  <span
                    v-if="item.staffIds.length == 0"
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >请选择></span
                  >
                  <span
                    v-else
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >{{ item.staffName }}</span
                  >
                </div>
              </div>
            </div>
            <div class="confirm-btn">
              <div class="flex-row space-between">
                <div class="msg">
                  <div class="nums total">
                    总数量:
                    <span>{{ totalNums }}</span>
                  </div>
                  <div class="total">
                    总积分:
                    <span class="moneys fontSize20"><span class="fontSize28 fb">{{ totalAmount }}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          
			  </div>
        <el-button class="save_btn" @click="saveMoney">确定核销</el-button>
      </div>
			<div class="left-box">
				<div class="tabs">
					<div class="content flex-row">
						<div
							class="tab-title"
							:class="[
								item.show ? 'active' : '',
							]"
							v-for="(item, index) in serveGoryList"
							:key="index"
							@click="handleLeftBox(item, index)"
						>
							<span>{{ item.name }}</span>
						</div>
					</div>
					<!-- <div class="back el-icon-back" @click="back"></div> -->
				</div>
				<div class="tabs-content scroll-auto">
          <!-- card-boxs -->
          <div class="card-boxs">
            <div
							class="card-box"
							v-for="(item, index) in list"
							:key="'serve' + index"
              	@click="handleSelected(item, index)">
							
								<div
									class="card-msg"
									:class="item.show ? 'active' : ''"
								>
									<!-- <el-image style="height: 111px;width: 111px;" :src="item.imgUrl?item.imgUrl:notImg"></el-image> -->
									<div class="msgs-content">
										<p class="names">{{ item.yskItemName }}</p>
										<p>原价￥{{item.salePrice}}</p>
                    <div class="flex-row" style="align-items: center;">
                      <p class="money names">
                        {{ item.integralPrice }}积分
                      </p>
                    </div>
									</div>
								</div>
							</div>
						</div>
				</div>
				<!-- <div class="mains-bottom">
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
        </div>-->
			</div>
			
		</div>
		<staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
    <payDialog title="支付效验" :hide="dialogHide" :price="totalAmount" :type="'integral'" 
    :memberId="form.memberId" @changeDialog="savePay"></payDialog>
    <pay-form ref="payEditForm" @payFun="payMoney" :orderId="orderId" :hintName="'兑换成功'" :amount="totalAmount" :foot="true"></pay-form>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import staffSet from '../../components/staff-set'
import payDialog from "../../components/pay-dialog";
import member from "../../components/member";
import payForm from "./pay";
import { decrypt, encrypt } from '../../../assets/javascript/untils'
export default {
	mixins: [minxin],
	components: { staffSet, member,  payDialog ,payForm },
	data() {
		return {
			formMobile: '',
			staffName: '',
			pageHeight: this.$store.getters.MainHeight,
			totalNums: 0,
			totalAmount: 0,
			activeName: 'serve',
			tabs: [
				{
					id: '0',
					type: 'serve',
					name: '服务',
					show: true,
				},
				{
					id: '1',
					type: 'product',
					name: '产品',
					show: false,
				},
			],
			serveGoryList: [], //服务分类
			list: [],
			productGoryList: [],
			productList: [],
			listSelected: [],
			form: {
				memberId: '',
				orderId: '',
				orderItemList: [],
			},
			idx: 0,
			popFlag: false,
			price: '',
			dialogHide: false,
      isSortFlag: false,
      shopInfo: {
        shopBizConfig:{}
      },
      orderId: '',
      toggleList: [],
      toggleFlag: false,
      userInfo: {}
		}
	},
	created() {
    this.shopInfo = this.$store.getters.ShopInfo;
		this.serveCategory();
		if (JSON.parse(localStorage.getItem('payMobile'))) {
			this.isPayPage()
		}
	},
	mounted() {
		this.topUpFun()
		this.listSelected = []
	},
	destroyed() {
		localStorage.removeItem('orderId')
	},
	methods: {
		topUpFun() {
      if (JSON.parse(localStorage.getItem("payMobile"))) {
        let arr = JSON.parse(localStorage.getItem("payMobile"));
        if (arr.path == this.$route.path) {
          this.$refs["paySuccessForm"].$emit("set", arr.res);
        }
      }
    },
    back() {
      this.$router.push("/dataList/integralOrder");
    },
    savePay(org) {
      if (org != "") {
        this.form.payCheckType = org.payCheckType;
        this.form.verifyCode = org.verifyCode;
        this.form.millisecond = new Date().getTime();
        this.$api.post(this.$url.integralItem.create, encrypt(JSON.stringify(this.form))).then(res => {
          console.log(res);
            if (res) {
              // this.isPayWayHide = false;
              this.dialogHide = false;
              this.orderId = res;
              this.$refs["payEditForm"].$emit("set", res);
            } else {
              this.$api.get(this.$url.order.getToken).then(res => {
                  if (res) {
                      this.form.repeatToken = res;
                      this.dialogHide = true;
                  }
              })
            }
          })
          .catch(error => {});
      } else {
        this.dialogHide = false;
      }
    },
    memberChange(value) {
      console.log(value);
      this.form.memberId = value.id;
      this.userInfo = value;
    },
    handleLeftBox(tab, index) {
      this.list = []
      this.productGoryList = []
      this.activeName = tab.types;
      for (let i in this.serveGoryList) {
        this.serveGoryList[i].show = false;
      }
      this.serveGoryList[index].show = true;
      this.serveList(tab.id);
    },
    dbclickBox() {
      this.totalAmount = 0;
      for (let i in this.listSelected) {
        this.totalAmount += this.listSelected[i].itemNum * this.listSelected[i].integralPrice;
      }
      this.totalAmount = this.totalAmount.toFixed(2)
    },
    deleteListSelected(item, index) {
      item.itemNum = Number(1)
      this.listSelected.splice(index, 1);
      this.handleChangeInput();
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: row.staffIds,
        index: index
      });
    },
    changePage(org) {
      if (org.staffIds) {
        let arr = []
        org.staffIds.map(item => {
          arr.push(item.staffName)
        })
        this.staffName = arr.join(",") + ">"
        this.$set(this.listSelected[org.nodeId], "staffIds", org.staffIds);
        this.$set(this.listSelected[org.nodeId], "staffName", this.staffName);
      }
      this.handleChangeInput();
    },
    payMoney(org) {},
    handleSelected(item, index) {
      let msg = JSON.parse(JSON.stringify(item))
      this.listSelected.push(msg);

      this.handleChangeInput();
    },
    handleChangeInput() {
      this.totalAmount = 0;
      this.totalNums = 0;
      for (let i in this.listSelected) {
        this.totalAmount += (this.listSelected[i].integralPrice * this.listSelected[i].itemNum);
        this.totalNums += this.listSelected[i].itemNum;
      }
    },
    payMoney(org) {
      if (org.path == "topUp") {
        this.topUpFun();
      }
    },
    saveMoney() {
      if (this.listSelected.length < 1) {
        this.$message.warning("请添加消费");
        return false;
      } else if (!this.form.memberId) {
        this.$message.error("请选择会员");
        return false;
      } else if (this.userInfo.integralAmount < this.totalAmount) {
        this.$message.warning("很抱歉，您的账户积分不足");
        return false;
      }
    console.log(this.userInfo.integralAmount,this.totalAmount);
      for (let i in this.listSelected) {
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning(this.listSelected[i].yskItemName + " 请选择技师");
          return false;
        }
      }
      this.form.orderItemList = this.listSelected;
      let arrIds = "",
        arrNames = "",
        obj = [];
        for (let i in this.form.orderItemList) {
            for (let j in this.form.orderItemList[i].staffIds) {
                if (j == 0) {
                    arrIds = this.form.orderItemList[i].staffIds[j].staffId;
                    arrNames = this.form.orderItemList[i].staffIds[j].staffName;
                } else {
                    arrIds += "," + this.form.orderItemList[i].staffIds[j].staffId;
                    arrNames += "," + this.form.orderItemList[i].staffIds[j].staffName;
                }
            }

            obj.push({
                itemId: this.form.orderItemList[i].id,
                itemType: this.form.orderItemList[i].itemType,
                itemNum: this.form.orderItemList[i].itemNum,
                itemName: this.form.orderItemList[i].yskItemName,
                salePrice: this.form.orderItemList[i].salePrice,
                staffIds: arrIds,
                staffNames: arrNames
            });
        }
        this.form.orderItemList = obj;
        this.form.sourceFrom = "order";
        this.$api.get(this.$url.order.getToken).then(res => {
            if (res) {
                this.form.repeatToken = res;
                this.dialogHide = true;
            }
        })
    },
    serveCategory() {
      //分类用的后台的接口
      this.serveGoryList = [];
      let arr = []
      this.$api.get(this.$url.integralItem.categroyList).then(res => {
          if (res && res.length != 0) {
            arr = res;
            for (let i in arr) {
              this.$set(arr[i], "show", false);
              this.$set(arr[i], "types", "serve");
            }
            this.$set(arr[0], "show", true);
            for (let i in arr) {
              this.serveGoryList.push(arr[i]);
            }
            this.serveList(this.serveGoryList[0].id);
          }
        });
    },
    // 失去焦点的时候 数量变为1
    blurItem (type, item) {
      this.totalAmount = 0;
      this.totalNums = 0;
      if (type == 'del' && item.itemNum > 0) {
        item.itemNum--;
      } else if (type == 'add' && item.itemNum < 99) {
        item.itemNum++;
      }
      for (let i in this.listSelected) {
        this.totalAmount += (this.listSelected[i].integralPrice * this.listSelected[i].itemNum);
        this.totalNums += this.listSelected[i].itemNum;
      }
    },
    serveList(id) {
      this.list = [];
      this.$api.post(this.$url.integralItem.list, {
          categoryId: id ? id : ""
        }).then(res => {
          if (res) {
            this.list = res;
            this.list.forEach((item, index) => {
              this.$set(item, "itemNum", 1);
              this.$set(item, "moneys", "");
              this.$set(item, "staffIds", []);
            });
          }
        });
    }
	},
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/edit.less';
@tabsColor: #4e89f8;
.fontWeight {
	font-weight: 700;
}
.collect-page {
  padding: 0 16px ;
  background-color: #e6edf5;
}
.mains-content {
	display: flex;
	height: 100%;
  margin: 16px 0;
  
	.left-box {
		width: 60%;
		// display: flex;
		// flex-wrap: wrap;
		overflow: hidden;
		position: relative;
    .serveNav {
      padding: 16px 0 16px 16px;
    }
		.tabs {
      position: relative;
      background: white;
			border-right: 1px solid #eee;
      margin-bottom: 8px;
      border-radius: 10px 10px 0px 0px;
      .screening {
				position: absolute;
        right: 10px;
        bottom: 0;
				text-align: center;
				.screening-icon {
					// width: 60px;
          display: flex;
					cursor: pointer;
          padding: 15px;
          .screening_img {
            display: inline-block;
            width: 14px;
            height: 14px;
          }
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            margin-left: 5px;
          }
				}
			}
      .content {
        width: 100%;
        padding: 16px 30px 0;
        border-bottom: 1px solid #EBEDF0;
      } 
			.tab-title {
        
				// display: flex;
				// align-items: center;
				// justify-content: center;
				overflow: auto;
        margin-right: 40px;
        padding-bottom: 10px;
        cursor: pointer;
				&:hover {
					border-bottom: 3px solid #3388FF;
          border-radius: 3px 3px 0px 0px;
					color: @tabsColor;
				}
			}
			.active {
				border-bottom: 3px solid #3388FF;
        border-radius: 3px 3px 0px 0px;
				color: @tabsColor;
			}
		}
		.mains-bottom {
			position: absolute;
			bottom: 0;
			left: 106px;
			background: #fff;
			z-index: 1;
			height: 63px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top: 1px solid @borderColor;
			width: calc(100% - 106px);
			box-sizing: border-box;
		}
		.tabs-content {
			flex: 1;
			position: relative;
			box-sizing: border-box;
			
			.card-boxs {
        display: flex;
        flex-wrap: wrap;
        height: calc(100vh - 210px);
        overflow: auto;
				.card-box {
          width: calc(19% - 30px);
					margin-right: 1%;
          height: 88px;
          padding: 15px;
          background: url("../../../assets/images/new/footBath_box.png") no-repeat;
          background-size: 100% 100%;
          margin-bottom: 8px;
          cursor: pointer;
					&:nth-of-type(5n) {
						margin-right: 0 !important;
					}
				}
				.card-msg {
					// width: 110px;
					// height: 50px;

					// justify-content: space-between;

					.msgs-content {
						height: 48px;
						padding: 3px 5px 0;
					}
					/deep/ .el-image img {
						height: 111px;
					}
					.names {
						font-size: 16px;
						padding-bottom: 20px;
						flex: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}
					.money {
						font-size: 18px;
						color: @money;
						font-weight: bold;
					}
					.icons {
						text-align: right;
						.icon {
							flex: 1;
							width: 14px;
							text-align: center;
							height: 14px;
							line-height: 14px;
							border: 1px solid #000;
							color: #000;
							border-radius: 50%;
							float: right;
							font-size: 14px;
						}
					}
				}
				// .noMargin {
				// 	margin-right: 0;
				// }
			}
		}
	}
  .member-box {
			width: calc(100% - 48px);
      padding: 15px 16px;
      background: #3388ff;
      border-radius: 10px 10px 0px 0px;
		}
  .page-left {
    width: 40%;
  }
	.right-box {
		background: url("../../../assets/images/new/footBath.png") no-repeat;
    background-position:center bottom; 
    margin-right: 16px;
		.right-box-empty {
      height: calc(100vh - 255px);
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }
		.shoping-titles {
			padding: 16px;
			font-size: 18px;
			font-weight: 700;
		}
		.contents-body {
			.tables-title {
        padding: 13px 16px;
        font-size: 14px;
        background: #F7F8FA;
			}
			.tables {
				padding: 0 0 16px;
				height: calc(100vh - 430px);
				box-sizing: border-box;
				.boxs {
					padding: 18px 16px 0;
					box-sizing: border-box;
          &:hover {
            border-left: 3px solid #3388FF;
            background: #f3f8fe;
          }
					.money {
						color: @money;
						font-weight: 500;
					}
					.nums {
            display: flex;
            justify-content: center;
            .del-img {
              width: 28px;
              height: 28px;
              cursor: pointer;
              img {
                width: 100%;
                height: 100%;
              }
            }
						/deep/ .el-input__inner {
              border-radius: inherit;
              text-align: center;
              padding: 0;
              border-left: none;
              border-right: none;
            }
					}
					.delete {
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: @blue;
						}
					}
				}
        
				.right-content {
					margin-top: 15px;
					display: flex;
          padding-bottom: 16px;
          border-bottom: 1px solid #EBEDF0;
				}
			}
			.confirm-btn {
				display: flex;
				align-items: center;
				margin: 0 16px;
				border-top: 1px solid #EBEDF0;
				padding: 12px 0;
				.flex-row {
					width: 100%;
					align-items: center;
          
					.msg {
            width: 100%;
						display: flex;
            justify-content: flex-end;
						font-weight: 500;
						.nums {
              line-height: 3;
							margin-right: 40px;
						}
					}
				}
			}
      
		}
    
	}
  .serve-box {
    width: 84px;
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    justify-content: center;
    border-radius: 16px;
    margin-right: 16px;
    color: #fff;
    cursor: pointer;
    // background: #3388FF;
    background: #E6F7FF;
    img {
      width: 100%;
      vertical-align: middle;
    }
    .serve-img {
      margin-right: 6px;
    }
  }
  .tabActive {
    color: #fff;
    background-color: #3388FF;
  }
}
.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #FF5449;
}
.goodName {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.stockCode /deep/ .el-dialog {
  margin-top: 30vh !important;
}
</style>
